// extracted by mini-css-extract-plugin
export default {"container":"tpupzb22BVvxHaAvyIEr3A==","link":"voMyUkKQuvizd9vyDVx+dg=="};